import React from 'react';
import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { body2 } from 'ui/theme/typography';
import { pxToRem } from 'utils/convert';
import { useCommonTranslations } from 'utils/hooks/useTranslation';
import { CUSTOM_RANGE } from '../helpers';

const RelativeDateWrapper = styled.ul`
  box-shadow: inset -${spacing.single} 0 ${spacing.quarter} ${colors.grey5};
  padding: ${pxToRem(20)} ${pxToRem(18)};
  margin: 0;
`;

const StyledDivider = styled.div`
  background: ${colors.grey5};
  height: ${spacing.single};
  margin: ${pxToRem(10)} 0;
`;

const PresetListItem = styled.li`
  list-style-type: none;
  ${body2};
  color: ${(props) => (props.selected ? colors.purple100 : colors.textPrimary)};
  background: ${(props) => (props.selected ? colors.purple10 : '')};
  padding: ${spacing.half};
  outline: none;
  border: solid ${spacing.single} transparent;
  border-radius: ${spacing.quarter};
  margin: ${spacing.single};
  &:hover {
    cursor: pointer;
    background: ${colors.grey5};
  }
  &:last-child {
    margin-top: ${spacing.base};
    margin-bottom: 0;
  }
  &:focus {
    border-color: ${colors.purple50};
    box-shadow: 0px 0px 0px 1px ${colors.purple50};
  }
`;

// type Props = {
//   /** Current relative date selection */
//   selectedPreset: string,
//   /** Function run when a new preset is chosen */
//   onPresetChange: (preset: string, updatedTimeZone?: string) => void,
//   /** Definition of time presets to display in menu */
//   presets: {},
// };

export const RelativeDateMenu = ({ selectedPreset, onPresetChange, presets }) => {
  const { t } = useCommonTranslations();
  return (
    <RelativeDateWrapper>
      {Object.keys(presets).map((presetKey) => {
        const { menuLabel } = presets[presetKey];
        const selected = selectedPreset === presetKey;
        return (
          <React.Fragment key={presetKey}>
            {presetKey === CUSTOM_RANGE && <StyledDivider />}
            <PresetListItem
              aria-selected={selected}
              selected={selected}
              onClick={() => onPresetChange(presetKey)}
              data-test={`${presetKey}-preset${selected ? `-selected` : ``}`}
              role="option"
              tabIndex={0}
            >
              {t(menuLabel)}
            </PresetListItem>
          </React.Fragment>
        );
      })}
    </RelativeDateWrapper>
  );
};
